import { graphql } from "../generated";

export const LineId = graphql(`
  query LineId($callId: ID!) {
    getCall(callId: $callId) {
      __typename

      ... on BasicCall {
        callId
        lineId
      }
    }
  }
`);
